import React, { useEffect, useRef, useState } from "react";
import { useBlogStore } from "../../store/blogStore.js";
import { Link } from "react-router-dom";
import {
  Table,
  ConfigProvider,
  Input,
  Select,
  DatePicker,
  Popconfirm,
} from "antd";
import moment from "moment";

import { VioletButtonLarge } from "../../components/button";


import images from "../../assets";

const { RangePicker } = DatePicker;

export default function Blog() {
  const { blogs, isLoading, getBlogs, deleteBlog } = useBlogStore();
  const tableRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [dateRange, setDateRange] = useState([]);

  useEffect(() => {
    fetchBlogs();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [blogs, searchText, statusFilter, dateRange]);

  const fetchBlogs = async () => {
    getBlogs({});
  };

  const applyFilters = () => {
    let filtered = blogs;

    if (searchText) {
      filtered = filtered?.filter(
        (item) =>
          item?.slug?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.title?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.metaDescription
            ?.toLowerCase()
            .includes(searchText?.toLowerCase())
      );
    }

    if (statusFilter) {
      filtered = filtered?.filter((item) => item?.status === statusFilter);
    }

    if (dateRange?.length === 2) {
      const [startDate, endDate] = dateRange;
      filtered = filtered?.filter((item) => {
        const publishDate = moment(item?.publishDate);
        return publishDate?.isBetween(startDate, endDate, "days", "[]");
      });
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleStatusChange = (value) => {
    setStatusFilter(value);
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };
  const handleDelete = (id) => {
    const payload = { id: id };
    deleteBlog(payload, () => {
      fetchBlogs();
    });
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);

    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const columns = [
    {
      title: "ID",
      width: 70,
      render: (text, record) => record?.id,
      key: "1",
    },
    {
      title: "Slug",
      width: 120,
      render: (text, record) => (
        <Link
          to={`https://noblemarriage.com/blog/${record?.slug}`}
          target="_blank"
        >
          {record?.slug}
        </Link>
      ),
      key: "2",
    },
    {
      title: "Blog Title",
      key: "3",
      width: 130,
      render: (text, record) => record?.title,
      fixed: "left",
    },
    {
      title: "Meta Title",
      key: "11",
      width: 130,
      render: (text, record) => record?.metaTitle,
      fixed: "left",
    },
    {
      title: "Meta Description",
      key: "4",
      render: (text, record) => record?.metaDescription,
      width: 150,
    },
    {
      title: "Category",
      key: "6",
      render: (text, record) => record?.category,
      width: 150,
    },
    {
      title: "Status",
      key: "7",
      render: (text, record) => record?.status,
      width: 70,
    },
    {
      title: "Featured Image",
      key: "8",
      render: (text, record) =>
        record?.featuredImage && (
          <img
            src={record?.featuredImage}
            className="h-[80px] aspect-auto"
            alt="blog img"
          />
        ),
      width: 150,
    },
    {
      title: "Publish Date",
      key: "10",
      render: (text, record) =>
        moment(record?.publishDate).format("DD.MM.YYYY"),
      width: 130,
    },
    {
      title: "Action",
      key: "17",
      fixed: "right",
      align: "center",
      width: 80,
      render: (text, record) => (
        <div className="flex gap-2 flex-wrap">
          <Link to={`/blog/${record?.id}`}>
            <img src={images.editIcon} alt="" />
          </Link>
          <Popconfirm
            title="Delete user?"
            description="Are you sure you want to delete this user?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <img src={images.deleteIcon} alt="" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full p-4 text-black">
      <div ref={tableRef}></div>
      <div className="mb-4 grid grid-cols-4 gap-5 items-end">
        <div className="flex flex-col gap-2 w-full">
          <div>Search</div>
          <Input
            style={{ height: 48 }}
            className="blog"
            placeholder="Keywords"
            onChange={(e) => handleSearch(e.target.value)}
            value={searchText}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div>Status</div>
          <Select
            style={{ height: 48 }}
            className="blog"
            placeholder="Filter by Status"
            onChange={handleStatusChange}
            allowClear
            options={[
              { value: "publish", label: "Published" },
              { value: "draft", label: "Draft" },
            ]}
            value={statusFilter}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div>Date range</div>
          <RangePicker
            style={{ height: 48 }}
            className="blog"
            onChange={handleDateChange}
            allowClear
          />
        </div>
        <Link to={"/addBlog"} className="w-max">
          <VioletButtonLarge text="Add Blog" />
        </Link>
      </div>
      <div>
        Total pages: <strong>{filteredData?.length}</strong>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#310048",
              headerColor: "#ffffff",
              cellFontSize: "14px",
              headerSortHoverBg: "#310048",
              headerSortActiveBg: "",
            },
          },
        }}
      >
        <Table
          className="user-list"
          bordered
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            pageSizeOptions: ["50", "100", "500", "1000"],
            showSizeChanger: true,
            total: filteredData.length,
          }}
          dataSource={filteredData}
          scroll={{
            x: 1500,
            y: 600,
          }}
          loading={isLoading}
          rowKey={(record) => record?.id}
          onChange={handleTableChange}
        />
      </ConfigProvider>
    </div>
  );
}








